"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgJob = function SvgJob(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7 3.43a9.644 9.644 0 0 1 1.3-.084c.538 0 .979.04 1.3.084a.5.5 0 0 1 .376.29c.12.241.25.52.365.805a80.966 80.966 0 0 0-4.082 0c.115-.285.245-.564.365-.805a.501.501 0 0 1 .376-.29ZM7.972 4.605c.192-.639.481-1.27.7-1.708a2.346 2.346 0 0 1 1.777-1.296c.397-.054.922-.101 1.551-.101.63 0 1.154.047 1.55.101.8.11 1.442.62 1.779 1.296.218.437.507 1.07.7 1.708 1.685.096 2.906.244 3.759.384 1.315.217 2.199 1.288 2.323 2.552.129 1.31.274 3.361.274 5.959 0 2.598-.145 4.648-.274 5.959-.124 1.264-1.008 2.335-2.323 2.552-1.422.234-3.869.489-7.788.489-3.92 0-6.366-.255-7.788-.489-1.315-.217-2.199-1.288-2.323-2.552a61.568 61.568 0 0 1-.274-5.959c0-2.598.145-4.648.274-5.959.124-1.264 1.008-2.335 2.323-2.552.853-.14 2.074-.288 3.76-.384Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgJob);
var _default = exports["default"] = Memo;